import { AUTOSAVE_ENABLED_KEY } from 'app/modules/wallforming/components/projects-manager/constants';
import { ProjectsDialog } from 'app/modules/wallforming/components/projects-manager/types/projectDialog';

import type { ProjectsSliceState } from 'app/modules/wallforming/components/state-management/placement/states/projectsSliceState';
import type { PlacementState } from 'app/modules/wallforming/components/state-management/placement/types';
import type { StateCreator } from 'zustand';

export const createProjectsSlice: StateCreator<PlacementState, [], [], ProjectsSliceState> = (set) => ({
    isProjectPanelOpen: false,
    setIsProjectPanelOpen: (open) => set({ isProjectPanelOpen: open }),

    activeProjectDialog: ProjectsDialog.NONE,
    setActiveProjectDialog: (dialog) => set({ activeProjectDialog: dialog }),

    activeProject: null,
    setActiveProject: (project) => set({ activeProject: project }),

    isDirty: false,
    setIsDirty: (dirty) => set({ isDirty: dirty }),

    isSaving: false,
    setIsSaving: (saving) => set({ isSaving: saving }),

    isAutosaveEnabled: typeof window !== 'undefined'
        ? localStorage.getItem(AUTOSAVE_ENABLED_KEY) !== 'false'
        : true,
    setIsAutosaveEnabled: (enabled) => set({ isAutosaveEnabled: enabled }),

    lastSavedSignature: '',
    setLastSavedSignature: (sig) => set({ lastSavedSignature: sig }),
});
